/**
 * 組織トップへの遷移先パスを組み立てる(同期・API呼び出しなし)。
 * initialExtraPageId があればその extraPage を、空/未設定ならバージョン一覧を指す。
 */
export const buildOrgTopPath = (
  orgId: string,
  initialExtraPageId: string | null | undefined
): string =>
  initialExtraPageId
    ? `/organizations/${orgId}/extra_pages/${initialExtraPageId}`
    : `/organizations/${orgId}`;
